export enum HistoryTypes {
	serviceRequest = 'ServiceRequest',
	scanRecord = 'ScanRecord',
	customerRegistrationRequest = 'CustomerRegistrationRequest'
}

export enum HistoryStatus {
	Added = 'Added',
	Modified = 'Modified',
	Unchanged = 'Unchanged'
}

export declare namespace HistoryEntity {
	interface Basic {
		author: BasicString
		updatedDate: BasicString
		changes: Record<
			string,
			{
				old: BasicString
				new: BasicString
				isDate: boolean | null
			}
		>
		childrenChanges: {
			childType: BasicString
			changes: Record<
				string,
				{
					old: BasicString
					new: BasicString
					isDate: boolean | null
				}
			>
			metadata: Record<string, string>
			status: HistoryStatus
		}[]
		metadata: Record<string, string>
		status: HistoryStatus
	}

	namespace BasicFormated {
		interface ChangesItem {
			label: BasicString
			newValue: BasicString
			oldValue: BasicString
		}

		interface Basic {
			author: BasicString
			changes: ChangesItem[]
			metadata: {
				label: BasicString
				value: BasicString
			}[]
			childrenChanges: {
				changes: ChangesItem[]
				metadata: {
					label: BasicString
					value: BasicString
				}[]
			}[]
			status: HistoryStatus
			updatedDate: BasicString
		}
	}
}
